// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__UO71Q","truncatedText":"styles_truncatedText___D9jW","fullText":"styles_fullText__P_RHw","textContainer":"styles_textContainer__UwSE4"};